export enum EMenuFlavors {
  NKOM = 'nkom',
  RATEL = 'ratel',
}
